<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 37 34"
    :fill="fillColor"
    :class="className"
  >
    <path
      d="M26.7303 0H9.79055C8.70585 0 7.75873 0.727442 7.48887 1.76853L1.05742 26.52C0.766406 27.6402 1.61829 28.7287 2.78235 28.7287H19.7221C20.8068 28.7287 21.7539 28.0012 22.0238 26.9602L28.4552 2.20868C28.7463 1.08853 27.8944 0 26.7303 0Z"
      fill="#005EDA"
    />
    <path
      d="M14.4707 5.27132C13.3966 5.27132 12.46 5.99876 12.1902 7.03984L5.81692 31.7913C5.52855 32.9115 6.3725 34 7.52598 34H24.3017C25.3758 34 26.3124 33.2726 26.5822 32.2315L32.9555 7.48C33.2439 6.35985 32.3999 5.27132 31.2464 5.27132H14.4707Z"
      fill="#F3004E"
    />
    <path
      d="M15.9462 9.96549H26.4466L27.653 5.26874H14.3668C13.3376 5.26874 12.4408 5.96719 12.1841 6.96874L10.2185 14.6201L10.2105 14.6596L10.1947 14.7202L9.00943 19.3353H19.4331C19.7056 19.3353 19.9067 19.5936 19.8379 19.8598L18.8881 23.5523C18.8167 23.8343 18.56 24.032 18.2717 24.032H7.80039L6.594 28.7287H18.8431C20.4675 28.6312 22.1845 28.1225 22.7745 26.0641L24.4915 19.3774L24.4994 19.3379L24.5153 19.2773C25.1158 16.9394 23.3565 14.6622 20.949 14.6622H14.7372L14.7477 14.6227L15.9435 9.96812L15.9462 9.96549Z"
      fill="white"
    />
    <path
      d="M29.1539 1.03845L29.4317 0H32.6064L32.3287 1.03845H31.3339L30.3974 4.62822H29.2201L30.1566 1.03845H29.1539Z"
      fill="white"
    />
    <path
      d="M34.9689 2.76217H33.572L33.0852 4.62822H31.9132L33.1275 0H34.2995L33.8419 1.72372H35.2387L35.6964 0H36.8684L35.6567 4.62822H34.4847L34.9689 2.76217Z"
      fill="white"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AceLogoIcon',
  props: {
    fillColor: {
      type: String,
      default: '#fff'
    },
    width: {
      type: [Number, String],
      default: 37
    },
    height: {
      type: [Number, String],
      default: 34
    },
    class: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const className = props.class
    return {
      className
    }
  }
})
</script>
